import styled from 'styled-components'

export const CommonBlogPostLayoutBodyWrapperUi = styled.div`
  position: relative;
  width: 100%;
`
